import { attempt } from 'shared/utils/attempt';

export function getWidth(node) {
  return attempt(() => node.getBoundingClientRect().width, 0);
}



// WEBPACK FOOTER //
// ./src/shared/utils/node.js